import { render, staticRenderFns } from "./NewCriterioCardInner.vue?vue&type=template&id=02060348&scoped=true"
import script from "./NewCriterioCardInner.vue?vue&type=script&lang=js"
export * from "./NewCriterioCardInner.vue?vue&type=script&lang=js"
import style0 from "./NewCriterioCardInner.vue?vue&type=style&index=0&id=02060348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02060348",
  null
  
)

export default component.exports